/* ============================================
   Lightbox (PhotoSwipe integration)
   ============================================ */

/* global PhotoSwipe, PhotoSwipeUI_Default */

function initPhotoSwipe(containerSelector) {
    'use strict';

    var container = document.querySelector(containerSelector);
    if (!container) return;

    var images = container.querySelectorAll('.kg-image-card img, .kg-gallery-card img');
    if (!images.length) return;

    var items = [];

    images.forEach(function (img, i) {
        img.style.cursor = 'pointer';
        img.setAttribute('data-pswp-index', i);

        var w = img.naturalWidth || parseInt(img.getAttribute('width')) || 1200;
        var h = img.naturalHeight || parseInt(img.getAttribute('height')) || 800;

        items.push({
            src: img.src,
            w: w,
            h: h,
            title: img.alt || ''
        });

        img.addEventListener('click', function () {
            openPhotoSwipe(parseInt(this.getAttribute('data-pswp-index')));
        });
    });

    function openPhotoSwipe(index) {
        var pswpElement = document.querySelector('.pswp');
        if (!pswpElement || typeof PhotoSwipe === 'undefined') return;

        var options = {
            index: index,
            bgOpacity: 0.92,
            showHideOpacity: true,
            closeOnScroll: false,
            fullscreenEl: true,
            zoomEl: false,
            shareEl: false,
            history: false
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }
}
